// extracted by mini-css-extract-plugin
export default {"checkbox":"select-all-cell_checkbox__vI4N6"};